import Repository from './repository'

export default {
  deleteMessage(messageId) {
    return Repository.delete(`/v1/admin/messages/${messageId}`)
  },
}
